import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { Button, styled } from "@mui/material";

// components
import { TabPerfomance } from "./tab-perfomance";
import { TabAreaDetails } from "./tab-area-details";
import { TabSite } from "./tab-site";

const StyledTabs = styled(Tabs)({
  padding: "0 16px",
  borderBottom: "1px solid #e8e8e8",
  "& .MuiTabs-indicator": {
    backgroundColor: "#efa21e",
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    minWidth: 0,
    [theme.breakpoints.up("sm")]: {
      minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    /* marginRight: theme.spacing(1), */
    color: "#343745",
    padding: "8px",
    "&:hover": {
      color: "#343745",
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "#343745",
      fontWeight: 600,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#343745",
    },
  }),
);

export const TabsResults = ({
  selectedBuilding,
  selectedResult,
  propertyArea,
  totalBuildingsArea,
  showGrid,
  setShowGrid,
  getSelectedGridIndex,
  setSelectedGridIndex,
  isSurvey
}) => {
  const [tabValue, setTabValue] = useState(0);
  const handleChange = (event, value) => {
    setTabValue(value);
  };

  useEffect(() => {
    if (selectedBuilding === null) {
      setTabValue(0);
    } else if (tabValue !== 1) {
      setTabValue(1);
    }
  }, [selectedBuilding]);

  useEffect(() => {
    setTabValue(0);
  }, [selectedResult]);

  return (
    <>
      <StyledTabs
        value={tabValue}
        onChange={handleChange}
        aria-label="ant example"
      >
        <StyledTab value={0} label={"Performance"} />
        <StyledTab
          value={1}
          label={"Area Details"}
          disabled={!selectedBuilding}
        />
        {/*  <StyledTab value={2} label={"Site"} /> */}
      </StyledTabs>
      {tabValue === 0 ? (
        <TabPerfomance
          selectedResult={selectedResult}
          propertyArea={propertyArea}
          isSurvey={isSurvey}
        />
      ) : tabValue === 1 && selectedBuilding ? (
        <TabAreaDetails
          selectedResult={selectedResult}
          selectedBuilding={selectedBuilding}
          totalBuildingsArea={totalBuildingsArea}
          showGrid={showGrid}
          setShowGrid={setShowGrid}
          getSelectedGridIndex={getSelectedGridIndex}
          setSelectedGridIndex={setSelectedGridIndex}
        />
      ) : tabValue === 2 ? (
        <TabSite />
      ) : null}
    </>
  );
};
